import Core from 'core/js/components/cities-select/list-layout/city-select/index.js'
export default Vue.extend({
  extends: Core,
  name: 'list-city-select-cust-gc',
})
